import styled from 'styled-components';
import {GameInfoButtonDefaultBox} from './game-info-button.default.box';


export const GameInfoButtonCasino777Box = styled(GameInfoButtonDefaultBox)`
    border-right: 1px solid $transparent;
`;